import produce from 'immer';
import initialState from '../initialState/versionHistory';
import * as versionHistoryActionTypes from '../../constants/actionTypes/versionHistory';

const versionHistory = (state = initialState, action) => produce(state, (draftState) => {
    switch (action.type) {
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY:
            draftState.versionHistory = draftState.versionHistory.concat(action.payload.items);
            draftState.isVersionHistoryLoaded = true;
            break;
        case versionHistoryActionTypes.CLEAR_VERSION_HISTORY:
            draftState.versionHistory = [];
            draftState.isVersionHistoryLoaded = false;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_ITEM_LOADED_STATUS:
            draftState.versionHistoryItem = {};
            draftState.isVersionHistoryItemLoaded = action.payload;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_ITEM:
            draftState.versionHistoryItem = action.payload;
            draftState.isVersionHistoryItemLoaded = true;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_ITEM_SAVING_STATUS:
            draftState.isVersionHistoryItemSaving = action.payload.isSaving;
            break;
        case versionHistoryActionTypes.UPDATE_VERSION_HISTORY_LATEST_SAVED_ITEM:
            draftState.latestVersionHistorySavedItem = action.payload;
            break;
        default:
    }
});

export default versionHistory;
